﻿// This is the JS that is specific to the "Custom Publishing Form"
/*Validate user input.*/
function ValidateInput() {
    let Pronoun = document.getElementById("cboPronoun").value.trim();
    Pronoun = encodeURIComponent(sanitizeInput(Pronoun.trim()));
    let FirstName = document.getElementById("txtFirstName").value.trim();
    FirstName = encodeURIComponent(sanitizeInput(FirstName.trim()));
    let LastName = document.getElementById("txtLastName").value.trim();
    LastName = encodeURIComponent(sanitizeInput(LastName.trim()));
    let Email = document.getElementById("txtEmail").value;
    let Phone = document.getElementById("txtPhone").value;
    Phone = encodeURIComponent(sanitizeInput(Phone.trim()));
    let Address1 = document.getElementById("txtAddress1").value;
    Address1 = encodeURIComponent(sanitizeInput(Address1.trim()));
    let Address2 = document.getElementById("txtAddress2").value;
    Address2 = encodeURIComponent(sanitizeInput(Address2.trim()));
    let City = document.getElementById("txtCity").value;
    City = encodeURIComponent(sanitizeInput(City.trim()));
    let State = document.getElementById("addressState").value;
    State = encodeURIComponent(sanitizeInput(State.trim()));
    let Zip = document.getElementById("txtPostalCode").value;
    Zip = encodeURIComponent(sanitizeInput(Zip.trim()));
    let Instutution = document.getElementById("txtInstitution").value;
    Instutution = encodeURIComponent(sanitizeInput(Instutution.trim()));
    let CourseName = document.getElementById("txtCourseName").value;
    CourseName = encodeURIComponent(sanitizeInput(CourseName.trim()));
    let TimesPerYear = document.getElementById("txtTimesPerYear").value;
    TimesPerYear = encodeURIComponent(sanitizeInput(TimesPerYear.trim()));
    let StudentsNumber = document.getElementById("txtNumberStudents").value;
    StudentsNumber = encodeURIComponent(sanitizeInput(StudentsNumber.trim()));
    let CurrentTexts = document.getElementById("txtCurrentTexts").value;
    CurrentTexts = encodeURIComponent(sanitizeInput(CurrentTexts.trim()));
    let RdlDecisionMaker;
    if (document.getElementById("rdlDecisionMakerYes").checked) {
        RdlDecisionMaker = "Yes";
    } else if (document.getElementById("rdlDecisionMakerNo").checked) {
        RdlDecisionMaker = "No";
    }
    let Author1 = document.getElementById("txtFinalAuthor1").value;
    Author1 = encodeURIComponent(sanitizeInput(Author1.trim()));
    let Title1 = document.getElementById("txtFinalTitle1").value;
    Title1 = encodeURIComponent(sanitizeInput(Title1.trim()));
    let ISBN1 = document.getElementById("txtFinalIsbn1").value;
    ISBN1 = encodeURIComponent(sanitizeInput(ISBN1.trim()));
    let Chapter1 = document.getElementById("txtFinalChapter1").value;
    Chapter1 = encodeURIComponent(sanitizeInput(Chapter1.trim()));
    let ChapterOrder1 = document.getElementById("txtFinalChapterOrder1").value;
    ChapterOrder1 = encodeURIComponent(sanitizeInput(ChapterOrder1.trim()));
    let Author2 = document.getElementById("txtFinalAuthor2").value;
    Author2 = encodeURIComponent(sanitizeInput(Author2.trim()));
    let Title2 = document.getElementById("txtFinalTitle2").value;
    Title2 = encodeURIComponent(sanitizeInput(Title2.trim()));
    let ISBN2 = document.getElementById("txtFinalIsbn2").value;
    ISBN2 = encodeURIComponent(sanitizeInput(ISBN2.trim()));
    let Chapter2 = document.getElementById("txtFinalChapter2").value;
    Chapter2 = encodeURIComponent(sanitizeInput(Chapter2.trim()));
    let ChapterOrder2 = document.getElementById("txtFinalChapterOrder2").value;
    ChapterOrder2 = encodeURIComponent(sanitizeInput(ChapterOrder2.trim()));
    let Author3 = document.getElementById("txtFinalAuthor3").value;
    Author3 = encodeURIComponent(sanitizeInput(Author3.trim()));
    let Title3 = document.getElementById("txtFinalTitle3").value;
    Title3 = encodeURIComponent(sanitizeInput(Title3.trim()));
    let ISBN3 = document.getElementById("txtFinalIsbn3").value;
    ISBN3 = encodeURIComponent(sanitizeInput(ISBN3.trim()));
    let Chapter3 = document.getElementById("txtFinalChapter3").value;
    Chapter3 = encodeURIComponent(sanitizeInput(Chapter3.trim()));
    let ChapterOrder3 = document.getElementById("txtFinalChapterOrder3").value;
    ChapterOrder3 = encodeURIComponent(sanitizeInput(ChapterOrder3.trim()));
    let DateNeeded = document.getElementById("date").value;
    DateNeeded = encodeURIComponent(sanitizeInput(DateNeeded.trim()));
    let RdlEbookFormat;
    if (document.getElementById("rdlEbookFormatYes").checked) {
        RdlEbookFormat = "Yes";
    } else if (document.getElementById("rdlEbookFormatNo").checked) {
        RdlEbookFormat = "No";
    }
    let RdlBookstore;
    if (document.getElementById("rdlBookstoreYes").checked) {
        RdlBookstore = "Yes";
    } else if (document.getElementById("rdlBookstoreNo").checked) {
        RdlBookstore = "No";
    } else if (document.getElementById("rdlBookstoreMaybe").checked) {
        RdlBookstore = "Maybe";
    }
    let SpecificRequirements = document.getElementById("txtSpecificRequirements").value;
    SpecificRequirements = encodeURIComponent(sanitizeInput(SpecificRequirements.trim()));
    let errMsg = "";
    if (FirstName.length == 0) {
        errMsg = errMsg + "<span> First Name</span>";
    }
    if (LastName.length == 0) {
        errMsg = errMsg + "<span> Last Name</span>";
    }
    if (Email.length == 0) {
        errMsg = errMsg + "<span> Email</span>";
    }
    if (Address1.length == 0) {
        errMsg = errMsg + "<span> Address Line 1</span>";
    }
    if (City.length == 0) {
        errMsg = errMsg + "<span> City</span>";
    }

    if ($('#addressState option:selected').prop('disabled') == true) {
        errMsg = errMsg + "<span> State</span>";
    }
    if (Zip.length == 0) {
        errMsg = errMsg + "<span> Zip/Postal Code</span>";
    }
    if (Instutution.length == 0) {
        errMsg = errMsg + "<span> Institution</span>";
    }
    if (CourseName.length == 0) {
        errMsg = errMsg + "<span> Course Name</span>";
    }
    if (TimesPerYear.length == 0) {
        errMsg = errMsg + "<span> Number of times per year the course is offerred</span>";
    }
    if (StudentsNumber.length == 0) {
        errMsg = errMsg + "<span> Number of students per course</span>";
    }
    if ($('input[name="rdlDecisionMaker"]:checked').length === 0) {
        errMsg = errMsg + "<span> Are you the sole decision maker for course material?</span>";
    }
    if (Author1.length == 0) {
        errMsg = errMsg + "<span> Author</span>";
    }
    if (Title1.length == 0) {
        errMsg = errMsg + "<span> Title of the Text</span>";
    }
    if (ISBN1.length == 0) {
        errMsg = errMsg + "<span> ISBN-13 Number</span>";
    }
    if (Chapter1.length == 0) {
        errMsg = errMsg + "<span> Chapter to be Included</span>";
    }
    if (DateNeeded.length == 0) {
        errMsg = errMsg + "<br><span> What date do you need this product to be ready and available for sale?</span><br>";
    }
    if ($('input[name="rdlEbookFormat"]:checked').length === 0) {
        errMsg = errMsg + "<span> Is an eBook only format acceptable?</span><br>";
    }
    if ($('input[name="rdlBookstore"]:checked').length === 0) {
        errMsg = errMsg + "<span> Does your college/university bookstore need to be able to sell it?</span>";
    }
    let result = {};
    if (errMsg.trim().length > 0) {
        errMsg = "<span><strong>PLEASE COMPLETE THE FOLLOWING REQUIRED FIELDS:</strong></span>" + errMsg;
        result = { isValid: "no", validationResult: errMsg };
    } else {
        let data = {
            "Pronoun": Pronoun,
            "FirstName": FirstName,
            "LastName": LastName,
            "Email": Email,
            "Phone": Phone,
            "Address1": Address1,
            "Address2": Address2,
            "City": City,
            "State": State,
            "Zip": Zip,
            "Instutution": Instutution,
            "CourseName": CourseName,
            "TimesPerYear": TimesPerYear,
            "StudentsNumber": StudentsNumber,
            "CurrentTexts": CurrentTexts,
            "RdlDecisionMaker": RdlDecisionMaker,
            "Author1": Author1,
            "Title1": Title1,
            "ISBN1": ISBN1,
            "Chapter1": Chapter1,
            "ChapterOrder1": ChapterOrder1,
            "Author2": Author2,
            "Title2": Title2,
            "ISBN2": ISBN2,
            "Chapter2": Chapter2,
            "ChapterOrder2": ChapterOrder2,
            "Author3": Author3,
            "Title3": Title3,
            "ISBN3": ISBN3,
            "Chapter3": Chapter3,
            "ChapterOrder3": ChapterOrder3,
            "DateNeeded": DateNeeded,
            "RdlEbookFormat": RdlEbookFormat,
            "RdlBookstore": RdlBookstore,
            "SpecificRequirements": SpecificRequirements,
            "Store": "us"
        };
        result = { isValid: "yes", validationResult: JSON.stringify(data) };
    }
    return result;
}

function Process() {
    PleaseWait("Your request is being processed.");
    //validate user input.
    var validationResult = ValidateInput();
    //display the error message if the input is not valid.
    if (validationResult.isValid.trim() == "no") {
        HideWait();
        ShowResult(validationResult.validationResult);
        return false;
    }
    //input is valid. 
    $.ajax({
        type: "Get",
        dataType: "json",
        url: "https://dnext.humankinetics.com/ECR/api/custom/process?data=" + validationResult.validationResult,
        contentType: "text/javascript",
        crossDomain: true,
        timeout: 20000, //need the timeout because .fail doesn't get called for cross domain requests.
        xhrFields: {
            withCredentials: true
        }
    }).done(function (data) {
        HideWait();
        //call was successful.
        if (data == "success") {
            ShowResult("<p>Your request has been received. A sales representative will contact you.</p><p><a href='/'>Continue Shopping</a></p>");
        } else {
            ShowResult("<p>We're sorry, an unexpected error occurred.</p><p>Try again later.</p><p><a href='/pages/find-a-sales-representative'>Contact your Sales Representative</a> if the error persists!</p>");
        }
    }).fail(function (xhr, textStatus, errorThrown) {
        HideWait();
        if (xhr.statusText === "success") {
            ShowResult("<p>Your request has been received. A sales representative will contact you.</p><p><a href='/'>Continue Shopping</a></p>");
        } else {
            ShowResult("<p>We're sorry, an unexpected error occurred.</p><p>Try again later.</p><p><a href='/pages/find-a-sales-representative'>Contact your Sales Representative</a> if the error persists!</p>");
        }

    });
}